import { filter } from 'ramda'

import { ConversationAPI } from 'api'

export const getABMPlaybookTotal = async () => {
  //todo: playbooks doesnt support filtering, so we have to do it on the FE - have them do it soon!

  const data = {
    reportType: 'ABM',
    size: 1
  }

  const isABM = playbook => playbook.reportType === 'ABM'

  return ConversationAPI.get(`/playbooks`, {params: data})
    .then(resp => filter(isABM, resp))
}
